import React, { Component, Fragment } from "react";
import formatCurrency from "../../../utils/currencyFormat";
import { summariseOrder } from "../../../utils/order";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class OrderSummary extends Component {
  state = {
    discounts: {
      meritFree: false,
      optionalTestDiscount: 0
    }
  };


  render() {
    const { basket } = this.props;

    const summarisedOrder = summariseOrder(basket);

    const QuantiyInfo = props => {
      const { descriptor, price, quantity, item } = props;
      return (
        <span>
          {descriptor}: <strong>{quantity}</strong>
        </span>
      );
    };

    const getQuantityInfo = (
      productID,
      extrausers,
      quantity,
      price,
      extrauserprice,
      canOrderMultiple
    ) => {
      if (canOrderMultiple) {
        return (
          <QuantiyInfo
            descriptor="Quantity"
            price={price}
            quantity={quantity}
            item="pack"
          />
        );
      } else {
        return (
          <QuantiyInfo
            descriptor="Additional simultaneous sessions"
            price={extrauserprice}
            quantity={extrausers}
            item="user"
          />
        );
      }
    };

    const packageSubtotal = (
      productID,
      quantity,
      additionalUsers,
      price,
      extrauserprice,
      canOrderMultiple
    ) => {
      if (canOrderMultiple) {
        return `£${Number(price * quantity).toFixed(2)}`;
      } else {
        return `£${Number(additionalUsers * extrauserprice).toFixed(2)}`;
      }
    };

    return (
      <Row className={"order-details"}>
        <Col xs={12} className={"order-table"}>
          <Row className={"order-table__header"}>
            <Col xs={12}>
              <h2 className="order-summary-header">Order Summary</h2>
            </Col>
          </Row>
          <Row className={"order-table__header"}>
            <Col xs={7} sm={9}>
              Package
            </Col>
            <Col            
              xs={5}
              sm={3}
              className={"text-right order-table__pad-fix"}
            >
              Price
            </Col>
          </Row>
          <div className="scroll-summary">
            {basket.map(subjectPackage => (
              <Fragment key={subjectPackage.packageID}>
                <Row className={"order-table__row"}>
                  <Col xs={7} sm={9}>
                    {subjectPackage.additionalusersallowed === 1 ? "*" : null}
                    {subjectPackage.Name}
                  </Col>
                  <Col
                    xs={5}
                    sm={3}
                    className={"text-right order-table__pad-fix"}
                  >
                    {!subjectPackage.canOrderMultiple &&
                      `£${Number(subjectPackage.price).toFixed(2)}`}
                  </Col>
                </Row>
                {!subjectPackage.canOrderMultiple &&
                !subjectPackage.additionalusersallowed ? null : (
                  <Row className={"order-table__row"}>
                    <Col xs={7} sm={9}>
                      {getQuantityInfo(
                        subjectPackage.productID,
                        subjectPackage.additionalUsers,
                        subjectPackage.packageQuantity,
                        subjectPackage.price,
                        subjectPackage.extrauserprice,
                        subjectPackage.canOrderMultiple
                      )}
                    </Col>
                    <Col
                      xs={5}
                      sm={3}
                      className={"text-right order-table__pad-fix"}
                    >
                      {packageSubtotal(
                        subjectPackage.productID,
                        subjectPackage.packageQuantity,
                        subjectPackage.additionalUsers,
                        subjectPackage.price,
                        subjectPackage.extrauserprice,
                        subjectPackage.canOrderMultiple
                      )}
                    </Col>
                  </Row>
                )}
              </Fragment>
            ))}
          </div>
        </Col>

        <Row className="order-table__calcs">
          <Col xs={7} lg={9} className="text-right">
            <strong>Subtotal:</strong>
          </Col>
          <Col xs={5} lg={3} className="text-right">
            {formatCurrency(summarisedOrder.subtotal)}
          </Col>
        </Row>
        <Row className="order-table__calcs">
          <Col xs={7} lg={9} className="text-right">
            <strong>Vat:</strong>
          </Col>
          <Col xs={5} lg={3} className="text-right">
            {formatCurrency(summarisedOrder.vat)}
          </Col>
        </Row>
        <Row className="order-table__calcs">
          <Col xs={7} lg={9} className="text-right">
            <strong>Total:</strong>
          </Col>
          <Col xs={5} lg={3} className="text-right order-table__total">
            <strong>{formatCurrency(summarisedOrder.total)}</strong>
          </Col>
        </Row>
      </Row>
    );
  }
}

export default OrderSummary;
